<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${coverWidth} ${coverHeight}`" xmlns="http://www.w3.org/2000/svg" @click="findCoords">
      <rect id="Frame" ref="frame" x="0" y="0" :width="coverWidth" :height="coverHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="bg" :transform-origin="`${coverWidth/2} ${coverHeight/2}`">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/wedding/Main-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/wedding/Main-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/wedding/Main-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/wedding/Main-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/wedding/Main.jpg`" />
            </picture>
          </foreignObject>
        </g>
      </g>
      <g ref="hearts" class="hearts">
        <image width="879" height="1004" transform="translate(237.36 29.04) scale(0.12)" x="1987" y="242" :xlink:href="`${publicPath}scenes/wedding/wedding2.png`" />
        <image width="783" height="904" transform="translate(236.88 29.04) scale(0.12)" x="1986" y="242" :xlink:href="`${publicPath}scenes/wedding/wedding3.png`" />
        <image width="883" height="1004" transform="translate(236.88 29.04) scale(0.12)" x="1986" y="242" :xlink:href="`${publicPath}scenes/wedding/wedding4.png`" />
        <image width="882" height="1004" transform="translate(236.88 29.04) scale(0.12)" x="1986" y="242" :xlink:href="`${publicPath}scenes/wedding/wedding5.png`" />
        <image width="756" height="926" transform="translate(236.88 30.84) scale(0.12)" x="1986" y="257" :xlink:href="`${publicPath}scenes/wedding/wedding6.png`" />
      </g>
    </svg>
    <SceneDialogue
      ref="d1"
      :width=".27" :tx="0" :ty=".5">
      Mr. Austin and his wife were getting older. Gertie, their youngest
      daughter, was still unmarried. The day after his visit, Grandpa Jim
      brought Max, who asked for Gertie’s hand in marriage.
    </SceneDialogue>
    <SceneDialogue
      ref="d2"
      :width=".28" :tx="1" :ty=".75">
      Max and Gertie were married in Navajo tradition in Tsegi Canyon. Max came
      with the bridal dowry. John Austin wrapped a leather tie around Max and
      Gertie's clasped hands and declared that they were married.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/wedding/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import {TimelineMax, TweenLite} from "gsap"

export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    coverWidth: 4175,
    coverHeight: 3006,
    showContent: false,
    heartTl: null,
  }),
  extends: Template,
  mounted() {
    const { bg, hearts, d1, d2 } = this.$refs
    TweenLite.set(bg, {opacity: 0, scale: 1.1})
    TweenLite.set(hearts, {opacity: 0})
    TweenLite.set(d1.$el, {opacity: 0})
    TweenLite.set(d2.$el, {opacity: 0})

    this.tl = new TimelineMax({paused: true})
    this.tl.add(TweenLite.to(bg, 3, {opacity: 1, scale: 1}), 0)
    this.tl.add(TweenLite.to(hearts, 3, {opacity: 1}), 2)
    this.tl.add(TweenLite.to(d1.$el, 1, {opacity: 1}), "-=0.5")
    this.tl.add(TweenLite.to(d2.$el, 1, {opacity: 1}))
  },
  methods: {
    enter() {
      this.tl.play()
    }
  },
  props: ["slide"]
}
</script>

<style lang="scss" scoped>
.hearts {
  image {
    animation: hearts 2s infinite;
    &:nth-of-type(1) { animation-delay: 0s; }
    &:nth-of-type(2) { animation-delay: -.4s; }
    &:nth-of-type(3) { animation-delay: -.8s; }
    &:nth-of-type(4) { animation-delay: -1.2s; }
    &:nth-of-type(5) { animation-delay: -1.6s; }
  }
}
@keyframes hearts {
  0% { opacity: 0; transform: translateY(200px) }
  50% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-200px) }
}
</style>
